__turbopack_context__.v({
  "errorMessage": "ProductSizeSelector-module-scss-module__-ys-yq__errorMessage",
  "labelContainer": "ProductSizeSelector-module-scss-module__-ys-yq__labelContainer",
  "singleSizeContainer": "ProductSizeSelector-module-scss-module__-ys-yq__singleSizeContainer",
  "singleSizeName": "ProductSizeSelector-module-scss-module__-ys-yq__singleSizeName",
});
